var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("path", {
      attrs: {
        d:
          "M9.18079 3.50349C11.1886 2.8142 13.3719 2.83316 15.3674 3.55721C16.4633 3.96747 17.4674 4.59016 18.322 5.38952C18.0316 5.70023 17.7253 5.99062 17.4291 6.29261C16.8658 6.85499 16.3029 7.41543 15.7405 7.97393C15.1799 7.43779 14.5017 7.04005 13.7601 6.8124C12.8111 6.52585 11.8015 6.50623 10.8421 6.75569C9.88267 7.00515 9.0105 7.51405 8.32126 8.22656C7.71963 8.83859 7.26401 9.57861 6.9884 10.3914L3.97858 8.06104C5.05592 5.92464 6.92125 4.29046 9.18079 3.50349Z",
        fill: "#EA4335"
      }
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d:
          "M3.18003 10.3696C3.34181 9.56783 3.61039 8.79139 3.97858 8.06104L6.9884 10.3972C6.59466 11.5567 6.59466 12.8137 6.9884 13.9732C5.98561 14.7476 4.98234 15.5258 3.97859 16.3079C3.05684 14.4731 2.77572 12.3827 3.18003 10.3696Z",
        fill: "#FBBC05"
      }
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d:
          "M12.1833 10.464H20.8251C21.1207 12.0856 21.0408 13.7535 20.5914 15.3395C20.1779 16.7979 19.3748 18.116 18.2683 19.1522C17.297 18.3943 16.3213 17.6422 15.35 16.8843C15.8315 16.5595 16.2426 16.1408 16.5584 15.6533C16.8743 15.1658 17.0884 14.6195 17.1881 14.0473H12.1833C12.1819 12.8538 12.1833 11.6589 12.1833 10.464Z",
        fill: "#4285F4"
      }
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d:
          "M3.97713 16.3079C4.98089 15.5336 5.98416 14.7553 6.98695 13.9732C7.37491 15.1118 8.11277 16.0987 9.09513 16.7928C9.70784 17.2259 10.4041 17.5265 11.1394 17.6756C11.864 17.8103 12.6072 17.8103 13.3318 17.6756C14.0543 17.5533 14.7432 17.2813 15.3543 16.8771C16.3257 17.635 17.3013 18.387 18.2727 19.1449C17.2097 20.1115 15.9139 20.7854 14.5122 21.1007C12.9651 21.4644 11.3527 21.4469 9.81382 21.0499C8.59669 20.7249 7.4598 20.152 6.47442 19.3671C5.43146 18.539 4.57961 17.4955 3.97713 16.3079Z",
        fill: "#34A853"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }